import { motion } from 'motion/react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OptionItemSquareLightStyles = styled(motion.div)<{
  isSelected: boolean;
  bgSrc: string;
}>`
  box-sizing: border-box;
  aspect-ratio: 0.83;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  cursor: pointer;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0.7) 100%
    ),
    ${({ bgSrc }) => `url(${bgSrc})`};
  background-repeat: no-repeat;
  background-size:
    100% 100%,
    cover;
  background-position: center;
  border-radius: 16px;
  position: relative;

  ${({ isSelected }) => {
    if (isSelected) {
      return `
            outline: 4px solid #BD18B1;
            outline-offset: -4px;
        `;
    }
  }}
`;

export const OptionItemSquareLightTitleStyles = styled(UiTypography)`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  margin: 0;
  font-weight: 600;
`;
